const setCountryList = data => ({
  type: "SET_COUNTRY_LIST",
  data
});

export const mutation = {
  setCountryList
};
